export class DeliveryApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Create a draft Send. */
    create(input) {
        return this.client.request({ method: 'POST', path: '/v1/deliveries', body: input, auth: true });
    }
    /** Read a delivery snapshot + revision + its chain of custody. */
    get(deliveryId) {
        return this.client.request({ method: 'GET', path: `/v1/deliveries/${encodeURIComponent(deliveryId)}`, auth: true });
    }
    /** One market's ops worklist: its deliveries in a status, newest first (D377: the market is required — `deliveries` is RLS'd). */
    listByStatus(status, marketId) {
        return this.client.request({ method: 'GET', path: `/v1/deliveries?status=${encodeURIComponent(status)}&marketId=${encodeURIComponent(marketId)}`, auth: true });
    }
    /** Confirm a draft through the fail-closed policy gate. */
    confirm(deliveryId, expectedPin) {
        return this.client.request({ method: 'POST', path: `/v1/deliveries/${encodeURIComponent(deliveryId)}/confirm`, body: expectedPin !== undefined ? { expectedPin } : {}, auth: true });
    }
    /** Append a custody event to the append-only chain. */
    recordCustody(deliveryId, input) {
        return this.client.request({ method: 'POST', path: `/v1/deliveries/${encodeURIComponent(deliveryId)}/custody`, body: input, auth: true });
    }
    /** Walk a plain lifecycle edge (never delivered/returned — those require proof). */
    advance(deliveryId, to) {
        return this.client.request({ method: 'POST', path: `/v1/deliveries/${encodeURIComponent(deliveryId)}/status`, body: { to }, auth: true });
    }
    /**
     * Complete a delivery with verified proof. A wrong PIN is a 409 `HANDOVER_PIN_MISMATCH` (problem `params: { attemptsRemaining }` — D577; the glued `detail`
     * `HANDOVER_PIN_MISMATCH:<left>` is deprecated), a spent budget `HANDOVER_PIN_LOCKED`, a Send a courier holds `HANDOVER_HELD_BY_COURIER`.
     */
    deliver(deliveryId, proof) {
        return this.client.request({ method: 'POST', path: `/v1/deliveries/${encodeURIComponent(deliveryId)}/deliver`, body: { proof }, auth: true });
    }
    /** Complete a return with verified proof. */
    return(deliveryId, proof) {
        return this.client.request({ method: 'POST', path: `/v1/deliveries/${encodeURIComponent(deliveryId)}/return`, body: { proof }, auth: true });
    }
}
//# sourceMappingURL=delivery.js.map